import { put, call, takeEvery } from 'typed-redux-saga';

import DiscountGateway from '~apis/discount';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetAllDiscountSettings(api: DiscountGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetAllDiscountAttempt', handleGetAllDiscountSettings, api);
}

function* handleGetAllDiscountSettings(api: DiscountGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getDiscountsFilterSettings], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetAllDiscountFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetAllDiscountSuccess(response.data));
    }
}
